import React, { useState, useEffect } from "react";
import classes from "../../style/Style.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../libs/axiosConfig";
import { selectPanNumber } from "../../Store/panNumberSlice";
import Toast from "../../Components/ToastMsg/Toast";
import { ToastContainer, toast } from "react-toastify";
import {
  ROUTE_UPDATED_PORT_FOLIO_SCREEN,
  ROUTE_CUSTOMER_SUPPORT_SCREEN,
  ROUTE_IIN_DEACTIVATED_SCREEN,
  ROUTE_DXTER_SCANNING,
  ROUTE_Purchase_CONFRIMATION_,
} from "../../Routes";
import { setTransactionNumber } from "../../Store/TransactionNoSlice";
// import { selectRefreshToken } from "../../Store/Token/refreshTokenSlice";
import { selectIINNumber } from "../../Store/IINSlice";
import { selectSelectedPortFolioTypeSlice } from "../../Store/SelectedPortFolioSlice";
import "../../style/Purchase.scss"

const ToastWithButton = ({ message }) => {
  const Navigate = useNavigate();
  const handleClick = () => {
    Navigate(ROUTE_DXTER_SCANNING);
  };

  return (
    <div>
      {message}
      <button onClick={handleClick} className={classes.ToastOkBtn}>
        OK
      </button>
    </div>
  );
};

const PurchaseOneTime = () => {
  const dispatch = useDispatch();
  // const transactionNumber = useSelector(selectTransactionNumber);

  const Navigate = useNavigate();
  const showToast = (errorMessage) => {
    Toast.error(<ToastWithButton message={errorMessage} />, {
      position: toast.POSITION.TOP_CENTER,
      autoClose: false,
    });
  };
  // const Navigate = useNavigate();
  const panNumber = useSelector(selectPanNumber);
  const SelectedPortFolioType = useSelector(selectSelectedPortFolioTypeSlice);
  console.log(SelectedPortFolioType);
  const userType = useSelector(
    (state) => state.portfolio.selectedPortfolioType
  );
  console.log(userType, "DONE");
  const [purchaseError, setPurchaseError] = useState("");
  const [sipError, setSipError] = useState("");
  const location = useLocation();
  const { IIN_Number } = location.state || {};
  // console.log(IIN_Number);
  const [showMonthlySip, setShowMonthlySip] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const iinNumber = useSelector(selectIINNumber);
  // console.log(iinNumber, "one time screen")
  const [showInitialValue, setShowInitialValue] = useState(true);
  const [clickedValueShowingContainer, setClickedValueShowingContainer] =
    useState(false);
  const [showOneTimeInvestment, setShowOneTimeInvestment] = useState(true);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(3);

  const [activeInput, setActiveInput] = useState("OneTimeInvestment");
  const [hasValueContainerClicked, setHasValueContainerClicked] =
    useState(false);
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  // const refreshToken = useSelector(selectRefreshToken);

  const updatedPortfolioData =
    useSelector((state) => state.updatedPortfolio.updatedPortfolioData) || {};
  // const ResidentValue = updatedPortfolioData.body.resident
  //  console.log(updatedPortfolioData,"data")
  const ResidentValue = updatedPortfolioData.resident || {};
  // console.log(updatedPortfolioData.resident);

  const portfolioTypeKey =
    Object.keys(updatedPortfolioData.portfolio_type || {})[0] || {};
  const portfolioType =
    updatedPortfolioData.portfolio_type?.[portfolioTypeKey] || {};

  const { risk, recommended_holding_period: recommendedHoldingPeriod } =
    portfolioType;

  const portfolioTypeKey2 =
    Object.keys(updatedPortfolioData.portfolio_type)[1] || null;
  const portfolioType2 =
    updatedPortfolioData.portfolio_type[portfolioTypeKey2] || null;
  console.log(portfolioType2);
  // //console.log(portfolioTypeKey2);

  const funds2 = portfolioType2 ? portfolioType2.funds : null;

  let purchase_onetime;
  let purchase_systematic;

  if (SelectedPortFolioType === "Card1") {
    purchase_onetime = portfolioType.min_total_amount_fresh_purchase_onetime;
    purchase_systematic = portfolioType.min_total_amount_fresh_purchase_systematic;
  } else if (SelectedPortFolioType === "Card2") {
    purchase_onetime = portfolioType2.min_total_amount_fresh_purchase_onetime;
    purchase_systematic = portfolioType2.min_total_amount_fresh_purchase_systematic;
  }

  console.log(purchase_onetime, purchase_systematic, "Data Collect");

  console.log(purchase_onetime, purchase_systematic, "Data Collect");

  const formatNumberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const formattedPurchaseOnetime = formatNumberWithCommas(
    purchase_onetime || ""
  );
  const formattedPurchaseSystematic = formatNumberWithCommas(
    purchase_systematic || ""
  );

  const defaultInvestmentAmount = "";
  const defaultMonthlySip = "";
  const [PurchaseValue, setPurchaseValue] = useState(
    formattedPurchaseOnetime || defaultInvestmentAmount
  );
  const [MonthSip, setMonthSip] = useState(
    formattedPurchaseSystematic || defaultMonthlySip
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (apiCallsInProgress > 3) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  if (!updatedPortfolioData || !Object.keys(updatedPortfolioData).length > 0) {
    return (
      <div className={classes.Null_Message_Container}>
        We are working on this {/* <span>Contact Dexterr Support Team</span> */}
        <button
          className={classes.Submit_button}
          onClick={() => Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN)}
        >
          Contact Dexterr Support Team
        </button>
      </div>
    );
  }

  const handleInputChange = (e) => {
    const rawValue = e.target.value;
    const numericValue = rawValue.replace(/\D/g, "");
    const formattedValue = formatNumberWithCommas(numericValue);
    setPurchaseValue(formattedValue);
  };

  const handleSIPInputChange = (e) => {
    const rawValue = e.target.value;
    const numericValue = rawValue.replace(/\D/g, "");
    const formattedValue = formatNumberWithCommas(numericValue);
    setMonthSip(formattedValue);
  };

  const handleClearButtonClick = () => {
    if (!clickedValueShowingContainer) {
      setPurchaseValue("");
    } else if (showMonthlySip) {
      setShowOneTimeInvestment(false);
      setShowInitialValue(false);
      setClickedValueShowingContainer(false);
    } else {
      setShowInitialValue(true);
      setShowOneTimeInvestment(true);
      setShowMonthlySip(true);
      setActiveInput("MonthlySIP");
      setClickedValueShowingContainer(false);
    }
  };

  const handleSIPClearButtonClick = () => {
    if (showOneTimeInvestment) {
      setShowOneTimeInvestment(true);
      setShowMonthlySip(false);
      setActiveInput("MonthlySIP");
      setShowInitialValue(!hasValueContainerClicked);
      setClickedValueShowingContainer(false);
    } else {
      setShowMonthlySip(false);
      setShowOneTimeInvestment(true);
      setActiveInput("OneTimeInvestment");
      setShowInitialValue(!hasValueContainerClicked);
      setClickedValueShowingContainer(false);
    }
    // setMonthSip("");
  };

  const handleValueShowingContainerClick = () => {
    setShowMonthlySip(true);
    setShowOneTimeInvestment(true);
    setShowInitialValue(true);
    setClickedValueShowingContainer(true);
    setHasValueContainerClicked(true);
  };

  const Handleproceed = async () => {
    const purchaseValueNumeric = parseInt(PurchaseValue.replace(/,/g, ""));
    const monthSipNumeric = parseInt(MonthSip.replace(/,/g, ""));

    if (PurchaseValue.trim() === "" && MonthSip.trim() === "") {
      // Toast.error("Both Value not present");
      return;
    }

    if (showOneTimeInvestment && PurchaseValue.trim() === "") {
      // Toast.error("Please enter the one-time investment amount");
      return;
    }

    if (showMonthlySip && MonthSip.trim() === "") {
      // Toast.error("Please enter the monthly SIP amount");
      return;
    }

    if (
      purchaseValueNumeric < parseInt(purchase_onetime) ||
      monthSipNumeric < parseInt(purchase_systematic)
    ) {
      return;
    }

    const purchaseTypes = [];

    if (
      showOneTimeInvestment &&
      purchaseValueNumeric >= parseInt(purchase_onetime)
    ) {
      purchaseTypes.push({
        type: "One Time Payment",
        amount: PurchaseValue,
      });
    }

    if (showMonthlySip && monthSipNumeric >= parseInt(purchase_systematic)) {
      purchaseTypes.push({
        type: "Monthly SIP",
        amount: MonthSip,
      });
    }

    if (purchaseValueNumeric < parseInt(purchase_onetime)) {
      setApiCallsInProgress(apiCallsInProgress - 1);

      return;
    }

    if (monthSipNumeric < parseInt(purchase_systematic)) {
      setApiCallsInProgress(apiCallsInProgress - 1);

      return;
    }

    if (PurchaseValue || MonthSip) {
      setApiCallsInProgress(apiCallsInProgress + 1);


      {
        const apiUrl =
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";

        const requestData = {
          nsePurchaseTrxn: {
            pan: panNumber,
            dexterr_portfolio: userType,
            resident: ResidentValue,
            iin: IIN_Number || iinNumber,
          },
        };
        const selectedPurchaseTypes1 = [];

        if (showOneTimeInvestment) {
          selectedPurchaseTypes1.push("One Time");
          requestData.onetime_purchase_amount = PurchaseValue.replace(/,/g, "");
        }

        if (showMonthlySip) {
          selectedPurchaseTypes1.push("Systematic");
          requestData.sip_purchase_amount = MonthSip.replace(/,/g, "");
        }

        if (selectedPurchaseTypes1.length === 2) {
          requestData.purchase_type = selectedPurchaseTypes1;
        } else if (selectedPurchaseTypes1.includes("One Time")) {
          requestData.purchase_type = ["One Time"];
          requestData.onetime_purchase_amount =
            requestData.onetime_purchase_amount || 0;
          requestData.sip_purchase_amount = 0;
        } else if (selectedPurchaseTypes1.includes("Systematic")) {
          requestData.purchase_type = ["Systematic"];
          requestData.onetime_purchase_amount = 0;
          requestData.sip_purchase_amount =
            requestData.sip_purchase_amount || 0;
        }
        console.log(
          SelectedPortFolioType === "Card1" ? userType : portfolioTypeKey2
        );
        const selectedPurchaseTypes = [];

        if (showOneTimeInvestment) {
          selectedPurchaseTypes.push("One Time");
          requestData.nsePurchaseTrxn.onetime_purchase_amount =
            PurchaseValue.replace(/,/g, "");
        }

        if (showMonthlySip) {
          selectedPurchaseTypes.push("Systematic");
          requestData.nsePurchaseTrxn.sip_purchase_amount = MonthSip.replace(
            /,/g,
            ""
          );
        }
        requestData.nsePurchaseTrxn.purchase_type = selectedPurchaseTypes;

        const axiosConfig = {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "application/json",
          },
        };

        axios
          .post(apiUrl, requestData, axiosConfig)
          .then((response) => {
            if (
              response.data.statusCode === 200 &&
              response.data.body &&
              response.data.body.iin !== "" &&
              response.data.body.iin_activation_status === "YES" &&
              response.data.body.dexterr_transaction_no &&
              response.data.body.input_ref_no
            ) {
              dispatch(
                setTransactionNumber(response.data.body.dexterr_transaction_no)
              );

              Navigate(ROUTE_Purchase_CONFRIMATION_, {
                state: { purchaseTypes },
              });
              // setIsProcessing(false);
              // setIsLoading(false);
            } else if (
              response.data.statusCode === 200 &&
              response.data.body &&
              response.data.body.iin !== "" &&
              response.data.body.iin_activation_status !== "YES"
            ) {
              setApiCallsInProgress(apiCallsInProgress - 1);

              const nseApiResponse = axios.post(
                "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                {
                  nseIINDetails: {
                    pan: panNumber,
                  },
                }
              );
              if (nseApiResponse.status === 200) {
                const secondApiResponseData = nseApiResponse.data;
                Navigate(ROUTE_IIN_DEACTIVATED_SCREEN, {
                  state: {
                    reason: secondApiResponseData.body.iin_deactivation_reason,
                  },
                });
                // setIsProcessing(false);
                // setIsLoading(false);
                setApiCallsInProgress(apiCallsInProgress - 1);
              } else {
                if (
                  !response.data.body.dexterr_transaction_no ||
                  !response.data.body.input_ref_no
                ) {
                  Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                    state: { reason: "Purchase transaction order failed" },
                  });
                }
              }
              // setIsProcessing(false);
              // setIsLoading(false);
              setApiCallsInProgress(apiCallsInProgress - 1);
            } else {
              Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
                state: { reason: "Purchase transaction order failed" },
              });
              Toast.error(
                response.data.errorMessage + " " + response.data.message ||
                "Error"
              );
              setApiCallsInProgress(apiCallsInProgress - 1);
            }
            if (response.status === 504) {
              Toast.error(
                response.data.errorMessage + " " + response.data.message ||
                "Error"
              );
              // console.log(response.status);
            } else {
              // Toast.error("Error");
            }
            const errorMessage = response.data.message;
            // Toast.error(errorMessage);
            // console.log(response.data.errorMessage);
            const errorMessageJson = JSON.parse(response.data.errorMessage);
            // console.log(errorMessageJson.message);

            const promiseOne = axios.post(apiUrl, requestData, axiosConfig);
            const promiseTwo = axios.post(apiUrl, requestData, axiosConfig);
            Promise.all([promiseOne, promiseTwo])
              .then((responses) => {
                // Handle responses from both API calls
                setIsLoading(false);
                // Process response data
              })
              .catch((error) => {
                setIsLoading(false);
                // Handle error from the second API call
              });
          })
          .catch((error) => {
            // console.error("Error making API call:", error);
            if (
              error.response &&
              error.response.data &&
              error.response.data.errorMessage
            ) {
              Toast.error(
                error.response.data.errorMessage +
                " " +
                error.response.data.message || "Error"
              );

              // Toast.error("Error");
            } else {
              // console.log(error.response.data.message);
              // Toast.error(error.response.data.message || "Error");
            }
            // setIsProcessing(false);
            // setIsLoading(false);
            setApiCallsInProgress(apiCallsInProgress - 1);
          });
      }
      // else {
      //   Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
      //     state: { reason: "Purchase Transaction Failed." },
      //   });
      // }
    } else {
      Toast.error("Error");
    }
  };
  const handleBackButton = () => {
    Navigate(ROUTE_DXTER_SCANNING);
  };

  return (
    <div className="purchase-main-container">
      <div className="purchase-header" >
        <ArrowBackIosIcon
          className="back-btn"
          onClick={handleBackButton}
        />
      </div>

      <div className="content-purchase-container">
        <div className="text-containers-purchase">
          <p className="heading-text-purchase">
            How much would you like to invest?
          </p>
          <span className="sub-heading-text-purchase">
            Minimum is ₹ {purchase_onetime} for One Time Investment
            <br />
            Minimum is ₹ {purchase_systematic} for SIP{" "}
            {/* <span className={classes.Sub_Heading_text_Purchase2}>Know why? </span> */}
          </span>
        </div>
        {(SelectedPortFolioType === "Card1" ||
          SelectedPortFolioType === "") && (
            <div className="Card1">
              <p className="CardText_Container1">
                <span className="Text_Dex_Zenith">
                  {portfolioTypeKey}
                </span>
                <span className="SubHeading_Text_Dex">{risk}</span>
              </p>
              <p className="CardText_Container1">
                <span className="SubHeading_Text_Dex">
                  Recommended Holding Period{" "}
                </span>
                <span className="SubHeading_Text_Dex2">
                  {recommendedHoldingPeriod}
                </span>
              </p>
            </div>
          )}
        {SelectedPortFolioType === "Card2" && (
          <div className="Card2">
            <p className="CardText_Container1">
              <span className="Text_Dex_Zenith">
                {portfolioTypeKey2}
              </span>
              <span className="SubHeading_Text_Dex">
                {portfolioType2.risk}
              </span>
            </p>
            <p className="CardText_Container1">
              <span className="SubHeading_Text_Dex">
                Recommended Holding Period{" "}
              </span>
              <span className="SubHeading_Text_Dex2">
                {portfolioType2.recommended_holding_period}
              </span>
            </p>
          </div>
        )}
        <div className={`Input_Filed_Box_Purchase ${clickedValueShowingContainer ? 'ValueShowingContainerClicked' : ''}`}>

          {showOneTimeInvestment && (
            <>
              <div className="Headings_Texts_Cofirmation">
                <p className="InputFiled_Top_Text">
                  One Time Investment
                </p>
                {(PurchaseValue.trim() === "" ||
                  parseInt(PurchaseValue.replace(/,/g, "")) <
                  parseInt(purchase_onetime)) && (
                    <p className="ErrorMessage">
                      Min. Amount {purchase_onetime}
                    </p>
                  )}
              </div>
              <div className="Input_Filed_Box">
                <div className="Input_Inner_Container">
                  <span className="RupeeSymbol">&#8377;</span>
                  <input
                    className={classes.Sip_InputFiled}
                    value={PurchaseValue}
                    onChange={handleInputChange}
                  />
                  {clickedValueShowingContainer && (
                    <button
                      className={classes.Cross_button}
                      onClick={handleClearButtonClick}
                    />
                  )}
                </div>
              </div>
              {purchaseError && (
                <p className="ErrorMessage">{purchaseError}</p>
              )}
            </>
          )}

          {/* {showInitialValue && !clickedValueShowingContainer && (
            <span className={classes.SubText1}>
              ₹ 3,44,400{" "}
              <span className={classes.SubText2}>in 3Y (20.01% p.a.)</span>{" "}
              <span className={classes.SubText3}>Disclosure</span>
            </span>
          )} */}

          {showMonthlySip && (
            <>
              <div className={classes.Headings_Texts_Cofirmation}>
                <p className={classes.InputFiled_Top_Text}>Monthly SIP</p>
                {/* {MonthSip.trim() === '' && (
                  <p className={classes.ErrorMessage}>Min. Amount {purchase_systematic}</p>
                )} */}
                {(MonthSip.trim() === "" ||
                  parseInt(MonthSip.replace(/,/g, "")) <
                  parseInt(purchase_systematic)) && (
                    <p className={classes.ErrorMessage}>
                      Min. Amount {purchase_systematic}
                    </p>
                  )}
              </div>
              <div className="Input_Filed_Box">
                <div className={classes.Input_Inner_Container}>
                  <span className={classes.RupeeSymbol}>&#8377;</span>
                  <input
                    className={classes.Sip_InputFiled}
                    value={MonthSip}
                    onChange={handleSIPInputChange}
                  />

                  <button
                    className={classes.Cross_button}
                    onClick={handleSIPClearButtonClick}
                  />
                </div>
              </div>
              {sipError && <p className={classes.ErrorMessage}>{sipError}</p>}
              {showInitialValue && (
                <span className={classes.ValuesText1}>
                  {/* ₹ 8,44,400 &nbsp; */}
                  {/* <span className={classes.ValuesText3}>
           in 3Y (20.01% p.a.){" "}
            <span className={classes.ValuesText4}>Disclosure </span>
            </span> */}
                </span>
              )}
            </>
          )}

          {!clickedValueShowingContainer && (
            <div
              className="Value_Showing_Container"
              onClick={handleValueShowingContainerClick}
            >
              <span className="ValuesText1">
                {/* {" "}
                ₹ 8,44,400{" "} */}
                <span className="ValuesText2">
                  Add a{" "}
                  {showOneTimeInvestment
                    ? ` Monthly SIP`
                    : ` One Time Investment `}{" "}
                </span>
                {/* <span className={classes.ValuesText3}>
                  in 3Y (20.01% p.a.){" "}
                  <span className={classes.ValuesText4}>Disclosure </span>
                </span> */}
              </span>
            </div>
          )}
        </div>
        <div className="Purchase_Button_Container">
          <p className="Note_text"></p>
          <button
            className="PortFolio_Button"
            onClick={Handleproceed}
            disabled={isProcessing}
          >
            Confirm and Review Portfolio
          </button>
        </div>
      </div>
      {isLoading && (
        <div className="overlay">
          <div className="loading_text">Please Wait...</div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default PurchaseOneTime;
